export const EPISODE = 'episode';
export const EPISODE_CLASS = 'Classification::Episode';
export const PLAN_TYPE = 'plan_type';
export const PLAN_TYPE_CLASS = 'Classification::PlanType';
export const HEALTH_PLAN = 'health_plan';
export const HEALTH_PLAN_CLASS = 'Classification::HealthPlan';
